<template>
    <div class="automation-action-settings">
        <div>
            <div class="field">
                <label
                    >{{ t('automations-form-actions-cashback-percentage_label') }}</label
                >
                <div class="input-group">
                    <input
                        class="form-control"
                        name="percentage_discount"
                        v-model="cashback_percentage"
                        type="number"
                        min="0"
                        max="100"
                    />
                    <div class="input-group-append">
                        <span class="btn btn-dark">{{ t('percent_symbol') }}</span>
                    </div>
                </div>
            </div>
            <div class="field">
                <label>{{ t('automations-form-actions-cashback-max_discount_label') }}</label>
                <div class="input-group">
                    <input
                        class="form-control"
                        name="max_discount"
                        v-model="max_discount"
                        type="number"
                        min="0"
                        max="100"
                    />
                    <div class="input-group-append">
                        <span class="btn btn-dark">{{ t('percent_symbol') }}</span>
                    </div>
                </div>
            </div>
            <div>
                <button @click.prevent="showCashbackExample = !showCashbackExample" class="mb-3 btn btn-sm btn-success">
                    <span v-if="showCashbackExample">{{ t('automations-form-actions-cashback-simulation_button_open') }}</span>
                    <span v-else>
                        {{ t('automations-form-actions-cashback-simulation_button_closed') }}
                    </span>
                </button>
                <div v-if="showCashbackExample" class="border p-3 rounded">
                    <div class="field">
                        <label>{{ t('automations-form-actions-cashback-example_value_label') }}</label>
                        <div class="input-group">
                            <input
                                class="form-control"
                                name="order_example_value"
                                v-model="order_example_value"
                                type="number"
                                min="0"
                            />
                            <div class="input-group-append">
                                <!-- i18n-validator-ignore-next-line: universal percentage symbol -->
                                <span class="btn btn-dark">%</span>
                            </div>
                        </div>
                    </div>

                    <p>
                        <small v-html="t('automations-form-actions-cashback-example_text', [formatNumber(order_example_value), formatNumber(computedCashback), formatNumber(computedCashbackMinPurchaseValue)])">
                        </small>
                    </p>
                </div>
            </div>
        </div>

    </div>
</template>
<style scoped>
strong {
    font-weight: 500;
}
</style>
<script>
export default {
    props: {
        properties: Object,
        conditions: Array,
    },
    data: function () {
        return {
            showCashbackExample: false,
            title: this.t("automations-form-actions-cashback-title"),
            cashback_percentage: this.properties.cashback_percentage
                ? this.properties.cashback_percentage
                : 0,
            max_discount: this.properties.max_discount
                ? this.properties.max_discount
                : 0,

            order_example_value: 200,
            money: {
                decimal: ".",
                thousands: "",
                prefix: "",
                suffix: "",
                precision: 2,
            },
        };
    },
    mounted: function () {
        this.$emit("mounted", this);
        this.$nextTick(() => {
            this.changed();
        });
    },
    computed: {
        trigger: function () {
            return this.$store.state.automationForm.trigger;
        },
        computedCashback: function () {
            return this.order_example_value * (this.cashback_percentage / 100);
        },
        computedCashbackMinPurchaseValue: function () {
            if (!this.max_discount) {
                return 0;
            }
            const discount = this.computedCashback;
            return discount / (this.max_discount / 100);
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        formatNumber(number) {
            if(!number) return 0;
            return parseFloat(number).toLocaleString("pt-BR");
        },
        isValid: function () {
            return true;
        },
        changed: function () {
            this.$emit("propertiesUpdated", {
                cashback_percentage: this.cashback_percentage,
                max_discount: this.max_discount,
            });
        },
    },
    watch: {
        cashback_percentage: function () {
            this.changed();
        },
        max_discount: function () {
            this.changed();
        },
    },
};
</script>
